import { batch } from 'react-redux';
import {
  setFirstSubmissionAttemptTimestamp,
  setPartialSubmissionStatus,
  setRetrySubmissionTimestamp,
  setSubmissionStatus,
} from '../Lib/redux/slices/submission';
import SubmissionStatus from '../Data/SubmissionStatus';

export const MAXIMUM_TIME_BETWEEN_SUBMISSION_ATTEMPTS = 30000;

/**
 * Following a failed submission, set the submission status and retry timestamps for the next submission attempt.
 *
 * @param {Object} args
 * @param {function} args.dispatch - The dispatch function from useDispatch.
 * @param {number} args.firstSubmissionAttemptTimestamp - The timestamp of the first submission attempt.
 * @param {number} args.currentSubmissionAttemptTimestamp - The timestamp of the current submission attempt.
 * @param {boolean} args.isResubmission - Whether the submission is a resubmission.
 *
 */
export const setAwaitingSubmissionRetry = ({
  dispatch,
  firstSubmissionAttemptTimestamp,
  currentSubmissionAttemptTimestamp,
  isResubmission,
  isSelectAndConnectResubmission,
  isPartial,
}) => {
  batch(() => {
    if (!firstSubmissionAttemptTimestamp) {
      dispatch(
        setFirstSubmissionAttemptTimestamp({
          firstSubmissionAttemptTimestamp: currentSubmissionAttemptTimestamp,
        })
      );
    }
    const timeSinceFirstSubmissionAttempt = firstSubmissionAttemptTimestamp
      ? Date.now() - firstSubmissionAttemptTimestamp
      : Date.now() - currentSubmissionAttemptTimestamp;
    const submissionRetryTimestamp = new Date(
      currentSubmissionAttemptTimestamp +
        Math.min(
          timeSinceFirstSubmissionAttempt,
          MAXIMUM_TIME_BETWEEN_SUBMISSION_ATTEMPTS
        )
    ).getTime();
    dispatch(setRetrySubmissionTimestamp({ submissionRetryTimestamp }));

    let submissionStatus = SubmissionStatus.AWAITING_RETRY_SUBMISSION;

    if (isResubmission) {
      submissionStatus = SubmissionStatus.AWAITING_RETRY_RESUBMISSION;
    }

    if (isSelectAndConnectResubmission) {
      submissionStatus =
        SubmissionStatus.AWAITING_RETRY_SELECT_AND_CONNECT_RESUBMISSION;
    }

    if (isPartial) {
      dispatch(
        setPartialSubmissionStatus({
          partialSubmissionStatus:
            SubmissionStatus.AWAITING_RETRY_PARTIAL_SUBMISSION,
        })
      );
      return;
    }

    dispatch(
      setSubmissionStatus({
        submissionStatus,
      })
    );
  });
};
